var View = require('views/base/view');
var LocaleService = require('services/locale-service');
var TimeoutService = require('services/timeout-service');
const DOMPurify = require('dompurify');

var TapAndDropQuestionView = View.extend({
  autoRender: true,
  template: require('./templates/tap-and-drop-question'),

  activitySettings: undefined,

  questionDelayTimeout: null,
  questionSelectionTimeout: null,

  questionAnswered: false,

  questionElements:undefined,
  prevSelectedElem:undefined,

  correctAnswer:undefined,
  answerArray:[],
  currentAnswerSet:[],

  selectedId:undefined,

  reversible:false,
  sequential:false,

  regions: {},

  load: function() {
    this.activitySettings = this.model.get('activitySettings');
    this.regions = this.model.get('regions');
    this.answerArray = this.model.get('answers');
    $('.tap-and-drop-submit-button').addClass('locked');
    this.initializeQuestion();
  },

  dispose:function() {
    this.clearQuestionTimers();
    View.prototype.dispose.apply(this, arguments);
  },

  // sets/renders a question based on the current position of the question iterator
  initializeQuestion: function() {
    this.correctAnswer = this.model.get('correct');
    this.reversible = this.model.get('reversible') ? this.model.get('reversible') : false;
    this.sequential = this.model.get('sequential') ? this.model.get('sequential') : false;
    this.questionElements = $(this.regions.question+' .question-answer');
    this.startQuestionTimers();
    this.questionAnswered = false;
    this.delegate('click', '.tap-and-drop-submit-button', ()=>{this.answerQuestion();});
    this.delegate('click', '.question-answer-container', (e)=>{this.selectElement(e);});
    this.delegate('click', '.question-answer', (e)=>{this.selectElement(e);});

    this.currentAnswerSet = [];
    let len = this.sequential?this.answerArray.length:1;
    for(var i = 0; i < len; i++) {
      this.currentAnswerSet.push(undefined);
    }

  },

  // clear timeouts and intervals if they exist
  clearQuestionTimers: function() {
    if(this.questionDelayTimeout !== null) {
      this.questionDelayTimeout.clear();
    }
    if(this.questionSelectionTimeout !== null) {
      this.questionSelectionTimeout.clear();
    }
  },


  // timeout that registers if the user takes too long to answer
  questionTimeout: function() {
    this.clearQuestionTimers();

    $(this.regions.question).addClass('unanswered incorrect');
    this.questionElements.removeClass('selected');
    this.applyAnswerClasses();

    this.trigger('question:timeout', {
      feedback: this.model.get('feedback'),
      answerElement: $('.tap-and-drop-submit-button')
    });
  },

  // kick off timers with the start of a new question
  startQuestionTimers: function() {
    if(this.activitySettings.question_timeout !== -1) {
      this.questionSelectionTimeout = new TimeoutService(this.activitySettings.question_timeout,
        ()=>{
          this.questionTimeout();
        });
      this.questionSelectionTimeout.play();
    }
  },

  // controls main user input logic
  selectElement:function(e) {
    let elem = $(e.currentTarget);
    // can we select the element?
    if(!this.checkSelect(elem)) { return; }


    // did we click something with an answer?
    let hasAnswer = elem.attr('answerid') !== undefined ? true : false;

    if(hasAnswer) {
      // console.log('here');
      let aId = parseInt(elem.attr('answerid'), 10);
      // have we already selected something else?
      if(this.selectedId) {
        // have we clicked the same thing again?
        if(this.selectedId === aId) {
          elem.toggleClass('selected');
          this.selectedId = undefined;
          this.prevSelectedElem = undefined;
        } else {
          this.swapContents(elem, this.prevSelectedElem);
          this.selectedId = undefined;
          this.prevSelectedElem = undefined;
        }
      } else {
        elem.toggleClass('selected');
        this.selectedId = aId;
        this.prevSelectedElem = elem;
      }
    } else {
      this.placeContents(elem, this.selectedId);
      this.selectedId = undefined;
      this.prevSelectedElem = elem;
    }
    this.checkAnswerSetFilled();
  },

  // something should not be selectable under these circumstances
  checkSelect: function(elem) {
    let aId = elem.attr('answerid');
    if(!this.selectedId && !aId) {
      return false;
    } else {
      return true;
    }
  },

  // have we filled the containers necessary to submit an answer
  checkAnswerSetFilled: function() {
    $('.tap-and-drop-submit-button').removeClass('unlocked locked');
    let filled = true;
    // console.log(this.currentAnswerSet);
    this.currentAnswerSet.forEach((e)=>{
      if(e === undefined) {
        filled = false;
      }
    });
    this.questionAnswered = filled;
    if(this.questionAnswered) {
      $('.tap-and-drop-submit-button').addClass('unlocked');
    } else {
      $('.tap-and-drop-submit-button').addClass('locked');
    }

  },

  // place contents into a container
  placeContents:function(elem, aId) {
    let isContainer = elem.hasClass('question-answer-container');

    // place the contents into the new box
      elem.addClass('placed');
      elem.find('.answer-text').html(this.getQuestionText(aId));
      elem.attr('answerid', aId);

    // if we placed into a container we must update the array
    if(isContainer) {
      let cId = elem.attr('containerid');
      this.currentAnswerSet[cId] = aId;

    }

    // clean up last selected
    if(this.prevSelectedElem) {
      this.prevSelectedElem.find('.answer-text').html('');
      this.prevSelectedElem.removeClass('selected placed').removeAttr('answerid');

      let isPrevContainer = this.prevSelectedElem.hasClass('question-answer-container');
      if(isPrevContainer) {
        let prevCid = this.prevSelectedElem.attr('containerid');
        this.currentAnswerSet[prevCid] = undefined;
      }
    }

    Chaplin.mediator.publish('game:element:placed', {
      element: elem,
      id:aId
    });
  },

  // swap contents of containers
  swapContents:function(elem, prevElem) {
    let isContainer = elem.hasClass('question-answer-container');
    let isPrevContainer = prevElem.hasClass('question-answer-container');

    let prevAid = parseInt(elem.attr('answerid'),10);
    let aId  = parseInt(prevElem.attr('answerid'),10);

    let text = this.getQuestionText(aId);
    let prevText = this.getQuestionText(prevAid);

    elem.addClass('placed');
    elem.find('.answer-text').html(text);
    elem.attr('answerid', aId);

    prevElem.find('.answer-text').html(prevText);
    prevElem.attr('answerid', prevAid);
    prevElem.removeClass('selected');

    if(isContainer) {
      let cId = elem.attr('containerid');
      this.currentAnswerSet[cId] = aId;
    }

    if(isPrevContainer) {
      let prevCid = prevElem.attr('containerid');
      this.currentAnswerSet[prevCid] = prevAid;
    }
  },

  // get text of the answer based on id
  getQuestionText:function(id) {
    let t = '';
    let len = this.answerArray.length;
    for(var i = 0; i < len; i++) {
      if(this.answerArray[i].id === id) {
        t = LocaleService.t(DOMPurify.sanitize(this.answerArray[i].text));
        break;
      }
    }
    return t;
  },

  // fired when the submit button is clicked, checks the answer selected
  answerQuestion: function() {
    if(!this.questionAnswered) return;

    this.$el.off('click', '.tap-and-drop-submit-button');
    this.$el.off('click', '.question-answer-container');
    this.$el.off('click', '.question-answer');

    this.clearQuestionTimers();

    let correct = this.checkQuestionCorrect();
    this.applyAnswerClasses(correct);
    $(this.regions.question).addClass(`answered ${correct === true?'correct':'incorrect'}`);

    this.questionDelayTimeout = new TimeoutService(this.activitySettings.question_delay,
      ()=>{
        this.trigger('question:feedback', {
          correct: correct,
          feedback: this.model.get('feedback'),
          answerElement: $('.game-container')
        });
    });
    this.questionDelayTimeout.play();
    this.trigger('question:answered', {
      correct: correct
    });
  },

  // apply classes to the answer elements based on whether they are inherently correct
  applyAnswerClasses: function(correct) {
    let c  = this.currentAnswerSet;
    let ca = this.correctAnswer;
    let elemArray = $('.placed');

    if(this.reversible) {
      let revCa = _.cloneDeep(ca).reverse();
      if(this.compareArraySimilarity(revCa, c) > this.compareArraySimilarity(ca, c)) {
        ca = revCa;
      }
    }
    for(var i = 0; i < elemArray.length; i++) {
      if(c[i] === ca[i]) {
        $(elemArray[i]).addClass('correct');
      } else {
        $(elemArray[i]).addClass('incorrect');
      }
    }
  },

  compareArraySimilarity: function(arr1, arr2) {
    let val = 0;
    for(var i = 0; i < arr1.length; i++) {
      if(arr1[i] === arr2[i]) val++;
    }
    return val;
  },

  // is the selected answer correct?
  checkQuestionCorrect: function() {
    let c = this.currentAnswerSet;
    if(this.sequential) {
      c = this.currentAnswerSet.join('').toString();
      let ca = this.correctAnswer.join('').toString();
      if(this.reversible) {
        return c.split('').reverse().join('') === ca || c  === ca;
      } else {
        return c  === ca;
      }
    } else {
      c = parseInt(c, 10);
      for(var i = 0; i < this.correctAnswer.length; i++) {
        if( parseInt(this.correctAnswer[i], 10) === c) {
          return true;
        }
      }
      return false;
    }
  }
});

module.exports = TapAndDropQuestionView;


